import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { PropsWithChildren } from "react";

const Layout = ({ children }: PropsWithChildren) => {
  return (
    <>
      <Header />
      {children}
      <div style={{ paddingInline: "20px" }}>
        <Footer />
      </div>
    </>
  );
};

export default Layout;
